import { render, staticRenderFns } from "./ProductDescDialog.vue?vue&type=template&id=5bfb860b&scoped=true"
import script from "./ProductDescDialog.vue?vue&type=script&lang=js"
export * from "./ProductDescDialog.vue?vue&type=script&lang=js"
import style0 from "./ProductDescDialog.vue?vue&type=style&index=0&id=5bfb860b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfb860b",
  null
  
)

export default component.exports